<template>
  <div>
    <v-row dense>
      <v-col>
        <b>Email (логин)</b>
      </v-col>
    </v-row>

    <v-row dense class="mb-4">
      <v-col>
        {{ formData.email }}
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" sm="6" md="12">
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          mode="eager"
          name="Имя пользователя"
        >
          <v-text-field
            id="form-text-field-lname"
            v-model="formData.name"
            outlined
            dense
            :readonly="readonly"
            label="Имя пользователя"
            maxlength="50"
            :error-messages="errors"
            placeholder="Введите имя пользователя"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <b>Пароль</b>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col class="d-flex align-center">
        <v-btn
          id="form-btn-change-password"
          outlined
          depressed
          color="primary"
          class="ml-2"
          @click="$emit('changePasswordDialog')"
        >
          <v-icon>
            mdi-pencil-outline
          </v-icon>
          Изменение пароля
        </v-btn>
      </v-col>
    </v-row>

    <v-row dense class="mt-4">
      <v-col>
        <b>Роли доступа</b>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <badge
          v-for="role in formData.roles"
          :key="role.id"
          :text="role.title"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed } from "vue";
import Badge from "@/components/Badge.vue";

export default {
  components: {
    Badge
  },

  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      loading: false
    };
  },

  setup(props, { emit }) {
    const formData = computed({
      get: () => props.value,
      set: val => emit("input", val)
    });

    return {
      formData
    };
  }
};
</script>
